import { JGY_EMBEDDED_AT_ROOT } from "@/constants/jgyEmbedded";
import { useTenant } from "@/context/TenantContext";
import { RouterProvider } from "@tanstack/react-router";
import { useMemo } from "react";
import { getRouter } from "@jain-gaurav-yatra/router";

const JGY_BASE = "jaingauravyatra";

export default function JainGauravYatraMount() {
  const { tenantId } = useTenant();
  const basepath = JGY_EMBEDDED_AT_ROOT ? "/" : `/${tenantId}/${JGY_BASE}`;

  const router = useMemo(() => getRouter({ basepath }), [basepath]);

  return <RouterProvider key={basepath} router={router} />;
}
